import React from 'react';
import { Switch, Icon } from 'antd';
import styled from 'styled-components';

var ColumnRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;

  &:last-child { border-bottom: none; }
`;

var ColumnIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${function(p) { return p.active ? '#e6f7ff' : '#f5f5f5'; }};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;

  .anticon {
    font-size: 14px;
    color: ${function(p) { return p.active ? '#1890ff' : '#bfbfbf'; }};
  }
`;

var ColumnInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

var ColumnName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${function(p) { return p.active ? '#262626' : '#8c8c8c'; }};
  transition: color 0.15s;
`;

var ColumnDesc = styled.div`
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 1px;
`;

var COLUMN_ICONS = {
  cnpj_formated: 'idcard',
  phone: 'phone',
  email: 'mail',
  activity: 'shop',
  cep: 'environment',
  street: 'home',
  number: 'number',
  neighborhood: 'compass',
  city: 'bank',
  state: 'flag',
};

var COLUMN_DESCS = {
  cnpj_formated: 'Documento de identificação',
  phone: 'Telefone de contato',
  email: 'Endereço de e-mail',
  activity: 'Atividade econômica',
  cep: 'Código postal',
  street: 'Logradouro',
  number: 'Número do endereço',
  neighborhood: 'Bairro',
  city: 'Município',
  state: 'Unidade federativa',
};

var AdditionalColumns = function(props) {
  var customerColumns = props.customerColumns;
  var customer_columns = props.customer_columns;
  var setCustomerColumns = props.setCustomerColumns;

  var keys = Object.keys(customerColumns);

  if (keys.length === 0) {
    return React.createElement('div', {
      style: { textAlign: 'center', padding: '24px 0', color: '#bfbfbf' }
    },
      React.createElement(Icon, { type: 'table', style: { fontSize: 32, marginBottom: 8, display: 'block' } }),
      React.createElement('span', { style: { fontSize: 13 } }, 'Nenhuma coluna disponível')
    );
  }

  return React.createElement('div', null,
    keys.map(function(item) {
      var isActive = customer_columns.includes(item);
      var iconType = COLUMN_ICONS[item] || 'bars';
      var desc = COLUMN_DESCS[item] || '';

      return React.createElement(ColumnRow, { key: item },
        React.createElement(ColumnIcon, { active: isActive },
          React.createElement(Icon, { type: iconType })
        ),
        React.createElement(ColumnInfo, null,
          React.createElement(ColumnName, { active: isActive }, customerColumns[item]),
          desc && React.createElement(ColumnDesc, null, desc)
        ),
        React.createElement(Switch, {
          size: 'small',
          checked: isActive,
          onChange: function(checked) {
            if (checked) {
              setCustomerColumns([].concat(customer_columns, [item]));
            } else {
              setCustomerColumns(customer_columns.filter(function(c) { return c !== item; }));
            }
          }
        })
      );
    })
  );
};

export default AdditionalColumns;
